exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logs-view[data-v-0f237f24] {\n  height: 600px;\n  overflow: scroll;\n  background: #5e71e400;\n}\n.logs-view tr[data-v-0f237f24]:hover {\n  background: #5e71e447;\n}\n", ""]);

// exports
